import React from 'react';

type Stat = {
  value: string;
  caption: string;
};

// COPY AMENDMENT: mockup L595 says "weeks" — changed to "days" per redesign copy review.
const STATS: Stat[] = [
  { value: '2 taps', caption: 'to book a session' },
  { value: '£0', caption: 'fixed monthly or annual fees' },
  { value: '1 app', caption: 'to run the whole club' },
  { value: 'days', caption: 'to go live' },
];

/** Stats band — source: mockup L590–598. */
const StatsBand = (): React.JSX.Element => (
  <section className="oq-stats">
    <div className="oq-container oq-stats__inner">
      {STATS.map((stat) => (
        <div className="oq-stats__tile" key={stat.caption}>
          <div className="oq-stats__value oq-bebas">{stat.value}</div>
          <div className="oq-stats__caption">{stat.caption}</div>
        </div>
      ))}
    </div>
  </section>
);

export default StatsBand;
